import React from "react";
import Head from "../../components/head";

function PublicAuthFrame({ title, children }) {
  return (
    <>
      <Head className="shadow-sm" />
      <div className="d-flex flex-column" style={{ minHeight: "100vh" }}>
        <div
          className="w-100 d-flex"
          style={{
            flex: 1,
            backgroundImage: `url(${process.env.PUBLIC_URL}/login-bg.png)`,
            backgroundPosition: "50%",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
        >
          <div className="m-auto container d-flex p-3 p-lg-5 justify-content-center w-100">
              <div
                className="rounded w-100"
                style={{
                  maxWidth: 480,
                  background: "hsla(0, 0%, 100%, .77)",
                  border: "1px solid #e8e8e8",
                  padding: "24px",
                }}
              >
                <h3
                  className="fw-bold mb-3"
                  style={{
                    color: "#191c79",
                    textAlign: "center",
                    paddingBottom: "1em",
                    borderBottom: "1px solid #ddd",
                  }}
                >
                  {title}
                </h3>
                {children}
              </div>
            </div>
          </div>
        <footer
          className="text-white text-center py-3"
          style={{
            marginTop: "auto",
            width: "100%",
            backgroundColor: "#22262a",
          }}
        >
          <div className="container">
            <div className="footer-content" style={{ fontSize: "14px" }}>
              Copyright © {new Date().getFullYear()}. All Rights Reserved.
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}

export default PublicAuthFrame;
